import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#14110f',
      },
    },
  },
  fonts: {
    heading: "'Trebuchet MS', 'Noto Sans KR', sans-serif",
    body: "'Noto Sans KR', 'Malgun Gothic', sans-serif",
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>,
);

reportWebVitals();
